import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import Dialog from '@material-ui/core/Dialog';

import { AppStyles, AppTheme } from '../styles/AppTheme';
import { CustomMessageDialogStyles } from '../styles/CustomStyles';
import { AppConfig } from '../AppConfig';
import { createStyles, makeStyles } from '@material-ui/core';
import { UiHelper } from '../common/helpers/UiHelper';

export class AdPreviewDialog extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  onCloseModal() {
    this.props.onClosed()
  }

  render() {
    console.log('items in preview',this.props)
    const useStyle = StyleSheet.create({
      htmlMainContainerSize : {
        width: this.props.orientation ? 1920 * .25 : 1080 * .25,
        height: this.props.orientation ? 1080 * .25 : 1920 * .25
      }
    })
    return (
      <Dialog
        open={this.props.isOpen}
        aria-labelledby={this.props.title}
        fullWidth={false}
        maxWidth='md'
        classes={{
          root: css(Styles.root),
          paper: css(Styles.paper),
        }}
      >
        <div className={css([Styles.modalHeader, AppStyles.modalHeader])}>
          <div className={css(Styles.modalTitle)}>{this.props.title}</div>
          <button className={css(Styles.modalCloseButton)} onClick={this.onCloseModal.bind(this)} disabled={this.state.inProcess}>
            {UiHelper.renderImg({key:'dialogCloseIcon'})}
          </button>
        </div>
        <div className={css(Styles.modalContent)}>
          <div className={css(Styles.previewContainer)}>
            <div className={css(Styles.htmlMainContainer,useStyle.htmlMainContainerSize)}>
              {this.props.htmlContent && <div className={css(Styles.htmlContainer)}
                dangerouslySetInnerHTML={{ __html: this.props.htmlContent }} >
              </div>}
            </div>
          </div>
        </div>
      </Dialog>
    );
  }
}

const Styles = AppConfig.CUSTOM_STYLE ? CustomMessageDialogStyles : StyleSheet.create({
  modalHeader: {
    padding: 20,
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 14
  },
  modalTitle: {
    color: '#222222',
    fontSize: 18,
    maxWidth: 180,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  modalContent: {
    // maxWidth: 400,
    minWidth: 200,
    padding:10,
    paddingTop: 0,
  },
  modalCloseButton: {
    position: 'absolute',
    top: 23,
    right: 30,
    padding: 0,
    border: 'none',
    backgroundColor: 'transparent',
    display: 'flex',
    outline: 'none',
    cursor: 'pointer',
  },
  modalCloseIcon: {
    width: 18,
    height: 18,
    padding: 1,
    fill: 'black',
    borderRadius: AppTheme.borderRadius
  },
  root: {
    zIndex: 13000,
  },
  paper: {
    borderRadius: AppTheme.borderRadius
  },
  contentImage: {
    maxWidth: '100%',
    maxHeight: 400,
    border: 'solid black 1px'
  },
  htmlMainContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    // width: 1080 * .25,
    // height: 1920 * .25,
    backgroundColor: 'blue',
    margin: 10,
    borderWidth: 1,
    borderColor: AppTheme.primaryColor
  },
  htmlContainer: {
    transform: 'scale(.25)',
    backgroundColor: 'red',
  },
  previewContainer: {
    // display: 'flex',
    // flexDirection: 'column',
    // //backgroundColor: 'yellow',
    // justifyContent: 'flex-start',
    // alignItems: 'center',
  },
})



// WEBPACK FOOTER //
// ./src/components/AdPreviewDialog.js